import React from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  Button, 
  Label, 
  FormGroup, 
  Input, 
  Alert 
} from 'reactstrap';
import Datetime from "react-datetime";
import moment from 'moment';
import Select from 'react-select';
// Components
import CurrencyInput from 'components/CurrencyInput/CurrencyInput';
// Helpers
import { formatPrice } from 'helpers/pricing';
// Requests
import { getPaymentsRequest } from 'api/payment'
// Styles
import './MarkAsSoldModal.css'
// Contexts
import ProjectContext from 'contexts/ProjectContext';

class MarkAsSoldModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      unit: {},
      modelsIndex: null,
      filtersClients: {},
      generateSpotPayment: false, 
      spotPaymentDate: null,
      spotPaymentAmount: null,
      generateDownPayments: false,
      totalDownPaymentMonths: null,
			firstDownPaymentDate: null,
			firstPrincipalCheckNumber: null,
			firstMiscCheckNumber: null,
			firstRentalCheckNumber: null,
			firstPrincipalBankName: null,
			firstMiscBankName: null,
			firstRentalBankName: null,
			principalAmount: null,
      miscelaneousAmount: null,
      rentalAmount: null,
      generateBalancePayment: false,
      balanceAmount: null,
			balancePaymentDate: null,
			balancePaymentCheckNumber: null,
			balancePaymentBankName: null,
			selectedSubtype: null,
			totalBalancePaymentMonths: null,
      reservationPayment: null
    };
    this.toggle = this.toggle.bind(this);
  }

  static contextType = ProjectContext;

  async componentDidMount() {
    
  }

  async toggle() {
    await this.getUnitPayments();

    this.setState((prevState) => ({
      modal: !prevState.modal,
      unit: {
        ...this.props.selectedUnit,
        client: this.props.selectedUnit.client
      }
    }));
  }

  getUnitPayments = async () => {
    const { _id, client } = this.props.selectedUnit;

    console.log('client', JSON.stringify(client))

    const paymentsObj = await getPaymentsRequest({
      limit: 0, 
      page: 0, 
      client: client._id,
      unit: _id,
      type: "downPayment",
      subtype: "reservation"
    });

    this.setState({
      reservationPayment: paymentsObj.payments[0]
    })

  }

  onChangeCheckbox = (e) => {
		const { target } = e;
		const { name, checked } = target;

		this.setState({
      [name]: checked,
    });

	}

  onChangeSelectedModelField = (e) => {
		const { target } = e;
		let { name, value } = target;

    this.setState(prevState => ({
      unit: {
        ...prevState.unit,
        selectedModel: {
          ...prevState.unit.selectedModel,
         [name]: value,
        }
      },
    }));
	}

  onChangeField = (e) => {
		const { target } = e;
		let { name, value } = target;

    this.setState({
      [name]: value,
    })
	}

  onSelectChange = (key) => (object)=> {
    const { models = [] } = this.props.selectedUnit
    const { value } = object;
    const model = models[value]
    this.setState(prevState => ({
			unit: {
				...prevState.unit,
				[key]: model,
        price: model?.price,
        vat: model?.vat,
        tcp: model?.tcp,
			},
      modelsIndex: value,
      [key]: object
		}));
  }

  onChangeAsyncSelect = (key) => (object) => {
      const { unit } = this.state;

    if(!object) {
      this.setState({
          unit: {
              ...unit, 
              [key]: "",
          },
      })

      return;
    }

    this.setState({
      unit: {  
          ...unit,
          [key]: object,
      }
    })
  }

  render() {
    const { 
       backdrop = false,
       onSave,
       loading,
       error
    } = this.props;

    const {
      client,
    } = this.state.unit

    const {
      unit,
      generateSpotPayment,
      spotPaymentDate,
      spotPaymentAmount,
      generateDownPayments,
      totalDownPaymentMonths,
      firstDownPaymentDate,
      firstPrincipalCheckNumber,
      firstMiscCheckNumber,
      firstRentalCheckNumber,
      firstPrincipalBankName,
      firstMiscBankName,
      firstRentalBankName,
      principalAmount,
      miscelaneousAmount,
      rentalAmount,
      generateBalancePayment,
      balanceAmount,
      balancePaymentDate,
      balancePaymentCheckNumber,
      balancePaymentBankName,
      selectedSubtype,
      totalBalancePaymentMonths,
      reservationPayment
    } = this.state;

    const saveData = {
      unit,
      generateSpotPayment,
      spotPaymentDate,
      spotPaymentAmount,
      generateDownPayments,
      totalDownPaymentMonths,
      firstDownPaymentDate,
      firstPrincipalCheckNumber,
      firstMiscCheckNumber,
      firstRentalCheckNumber,
      firstPrincipalBankName,
      firstMiscBankName,
      firstRentalBankName,
      principalAmount,
      miscelaneousAmount,
      rentalAmount,
      generateBalancePayment,
      balanceAmount,
      balancePaymentDate,
      balancePaymentCheckNumber,
      balancePaymentBankName,
      selectedSubtype,
      totalBalancePaymentMonths,
      tcp: unit?.selectedModel?.tcp,
      reservation_amount: reservationPayment?.amount
    }

    return (
      <Modal backdrop={backdrop} className="mark-sold" isOpen={this.state.modal} toggle={this.toggle} style={{marginTop: '-120px'}}>
        <ModalHeader toggle={this.toggle}>Mark Selected Unit as Sold</ModalHeader>
        <ModalBody>
          <Container className="p-2">
            <Row>
              <Col>
                <FormGroup>
                    <Label>Selected Model</Label>
                    <Input
                      name="models"
                      type="text"
                      value={unit?.selectedModel?.name || "N/A"}
                      disabled
                    />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                    <Label>Price</Label>
                    <Input
                      name="models"
                      type="text"
                      value={formatPrice(unit?.selectedModel?.price ?? 0) || "N/A"}
                      disabled
                    />
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                    <Label>TCP</Label>
                    <Input
                      name="models"
                      type="text"
                      value={formatPrice(unit?.selectedModel?.tcp ?? 0) || "N/A"}
                      disabled
                    />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Client</Label>
                  <Input
                    name="client"
                    type="text"
                    value={client ? `${client.first_name} ${client.last_name}` : "N/A"}
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Reservation Payment</Label>
                  <Input
                    name="reservationPayment"
                    type="text"
                    value={reservationPayment ? formatPrice(reservationPayment.amount) : "N/A"}
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <div className="form-check">
                <label className="form-check-label">
                  <input className="form-check-input" onChange={this.onChangeCheckbox} name="generateSpotPayment" type="checkbox" checked={!!generateSpotPayment} />
                  Generate Spot Payment
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
            </FormGroup>
            {generateSpotPayment && 
              <>
                <FormGroup>
                  <Label>Spot Payment Date <span className="required-start">*</span></Label>
                  <Datetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date of spot payment",
                      name: "spotPaymentDate"
                    }}
                    dateFormat="MM/DD/YYYY"
                    timeFormat={false}
                    value={typeof spotPaymentDate === 'string' ? moment(spotPaymentDate).format("MM/DD/YYYY") : spotPaymentDate}
                    onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "spotPaymentDate" }})}
                    closeOnSelect={true}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Spot Payment Amount <span className="required-start">*</span></Label>
                  <CurrencyInput 
                    name="spotPaymentAmount"
                    price={spotPaymentAmount || 0}
                    onChange={(value) => this.onChangeField({ target: { name: "spotPaymentAmount", value } })}
                    placeholder="Spot Payment Amount"
                  />
                </FormGroup>
              </>
            }
            <FormGroup>
              <div className="form-check">
                <label className="form-check-label">
                  <input className="form-check-input" onChange={this.onChangeCheckbox} name="generateDownPayments" type="checkbox" checked={!!generateDownPayments} />
                  Generate Down Payments
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
            </FormGroup>
            {generateDownPayments && 
              <>
                <FormGroup>
                  <Label>Total Months <span className="required-start">*</span></Label>
                  <Input
                    type="number"
                    name="totalDownPaymentMonths"
                    value={totalDownPaymentMonths}
                    onChange={this.onChangeField}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>First Payment <span className="required-start">*</span></Label>
                  <Datetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date of first payment",
                      name: "firstDownPaymentDate"
                    }}
                    dateFormat="MM/DD/YYYY"
                    timeFormat={false}
                    value={typeof firstDownPaymentDate === 'string' ? moment(firstDownPaymentDate).format("MM/DD/YYYY") : firstDownPaymentDate}
                    onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "firstDownPaymentDate" }})}
                    closeOnSelect={true}
                  />
                  <span className="form-text">
                    {`Subsequent payments will be generated for the amount of months provided.`}
                  </span>
                </FormGroup>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>Principal Amount</Label>
                      <CurrencyInput 
                        name="principalAmount"
                        price={principalAmount || 0}
                        onChange={(value) => this.onChangeField({ target: { name: "principalAmount", value } })}
                        placeholder="Total amount for principal payments"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>First Check Number: Principal</Label>
                      <Input
                        type="number"
                        name="firstPrincipalCheckNumber"
                        value={firstPrincipalCheckNumber}
                        onChange={this.onChangeField}
                      />
                      <span className="form-text">
                        {`This number will be used for the first payment and subsequent payments will have +1 added to the number. Leave blank if payment method is CASH`}
                      </span>
                    </FormGroup>
                  </Col>
                  {!!firstPrincipalCheckNumber ? <Col sm={12}>
                    <FormGroup>
                      <Label>Bank Name</Label>
                      <Input
                        type="text"
                        name="firstPrincipalBankName"
                        value={firstPrincipalBankName}
                        onChange={this.onChangeField}
                      />
                    </FormGroup>
                  </Col> : null}
                </Row>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>Misc. Amount</Label>
                      <CurrencyInput 
                        name="miscelaneousAmount"
                        price={miscelaneousAmount || 0}
                        onChange={(value) => this.onChangeField({ target: { name: "miscelaneousAmount", value } })}
                        placeholder="Total amount for miscelaneous payments"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup>
                        <Label>First Check Number: Miselaneous</Label>
                        <Input
                          type="number"
                          name="firstMiscCheckNumber"
                          value={firstMiscCheckNumber}
                          onChange={this.onChangeField}
                        />
                        <span className="form-text">
                          {`This number will be used for the first payment and subsequent payments will have +1 added to the number. Leave blank if payment method is CASH`}
                        </span>
                    </FormGroup>
                  </Col>
                  {!!firstMiscCheckNumber ? <Col sm={12}>
                    <FormGroup>
                      <Label>Bank Name</Label>
                      <Input
                        type="text"
                        name="firstMiscBankName"
                        value={firstMiscBankName}
                        onChange={this.onChangeField}
                      />
                    </FormGroup>
                  </Col> : null}
                </Row>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>Rental Amount</Label>
                      <CurrencyInput 
                        name="rentalAmount"
                        price={rentalAmount || 0}
                        onChange={(value) => this.onChangeField({ target: { name: "rentalAmount", value } })}
                        placeholder="Total amount for rental payments"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup>
                        <Label>First Check Number: Rental</Label>
                        <Input
                          type="number"
                          name="firstRentalCheckNumber"
                          value={firstRentalCheckNumber}
                          onChange={this.onChangeField}
                        />
                        <span className="form-text">
                          {`This number will be used for the first payment and subsequent payments will have +1 added to the number. Leave blank if payment method is CASH`}
                        </span>
                    </FormGroup>
                  </Col>
                  {!!firstRentalCheckNumber ? <Col sm={12}>
                    <FormGroup>
                      <Label>Bank Name</Label>
                      <Input
                        type="text"
                        name="firstRentalBankName"
                        value={firstRentalBankName}
                        onChange={this.onChangeField}
                      />
                    </FormGroup>
                  </Col> : null}
                </Row>
              </>

            }
            <FormGroup>
              <div className="form-check">
                <label className="form-check-label">
                  <input className="form-check-input" onChange={this.onChangeCheckbox} name="generateBalancePayment" type="checkbox" checked={!!generateBalancePayment} />
                  Generate Balance Payment
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
            </FormGroup>
            {generateBalancePayment && 
              <>
                <FormGroup>
                  <Label>Subtype <span className="required-start">*</span></Label>
                  <Select
                    value={selectedSubtype}
                    name="selectedSubtype"
                    options={[
                      {
                        label: "Single",
                        value: "single"
                      },
                      {
                        label: "Multiple",
                        value: "multiple"
                      }
                    ]}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={this.onSelectChange('selectedSubtype')}
                  />
                </FormGroup>
                {selectedSubtype && selectedSubtype.value === "multiple" &&
                  <FormGroup>
                    <Label>Total Months <span className="required-start">*</span></Label>
                    <Input
                      type="number"
                      name="totalBalancePaymentMonths"
                      value={totalBalancePaymentMonths}
                      onChange={this.onChangeField}
                    />
                  </FormGroup>
                }
                <FormGroup>
                  <Label>{selectedSubtype && selectedSubtype.value === "multiple" ? "Individual Payment Amount" : "Balance Amount"} <span className="required-start">*</span></Label>
                  <CurrencyInput 
                    name="balanceAmount"
                    price={balanceAmount || 0}
                    onChange={(value) => this.onChangeField({ target: { name: "balanceAmount", value } })}
                    placeholder="Balance Amount"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>{selectedSubtype && selectedSubtype.value === "multiple" ? "First Balance Payment Date" : "Balance Payment Date"} <span className="required-start">*</span></Label>
                  <Datetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date of balance payment",
                      name: "balancePaymentDate"
                    }}
                    dateFormat="MM/DD/YYYY"
                    timeFormat={false}
                    value={typeof balancePaymentDate === 'string' ? moment(balancePaymentDate).format("MM/DD/YYYY") : balancePaymentDate}
                    onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "balancePaymentDate" }})}
                    closeOnSelect={true}
                  />
                </FormGroup>
                <FormGroup>
                <Label>Check Number</Label>
                  <Input
                    type="number"
                    name="balancePaymentCheckNumber"
                    value={balancePaymentCheckNumber}
                    onChange={this.onChangeField}
                  />
                  <span className="form-text">
                    {`Leave blank if payment method is CASH`}
                  </span>
                </FormGroup>
                {!!balancePaymentCheckNumber ? <FormGroup>
                  <Label>Bank Name</Label>
                  <Input
                    type="text"
                    name="balancePaymentBankName"
                    value={balancePaymentBankName}
                    onChange={this.onChangeField}
                  />
                </FormGroup> : null}
                {selectedSubtype && selectedSubtype.value === "multiple" &&
                  <span className="form-text">
                    {`Subsequent payments will be generated for the amount of months provided.`}
                  </span>
                }
              </>
            }
            {error && 
              <Alert color="danger">
                {error.message}
              </Alert>
            }
          </Container>
        </ModalBody>
        <ModalFooter className="justify-content-end">
						<Button 
							color="primary" 
							className="btn-success-override mr-2" 
							onClick={() => onSave(saveData)}
							disabled={loading}
						>
							{loading ? "Saving" : "Save"}
						</Button>
						<Button color="secondary" className="btn-danger-override" onClick={this.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default MarkAsSoldModal;
